import { render, staticRenderFns } from "./UserPicList.vue?vue&type=template&id=3a389254&"
import script from "./UserPicList.vue?vue&type=script&lang=js&"
export * from "./UserPicList.vue?vue&type=script&lang=js&"
import style0 from "./UserPicList.vue?vue&type=style&index=0&id=3a389254&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports